<template>
  <div class="purchase transfer__wrapper">
    <form-layout
      :main-title="$t('superPass.purchase.title')"
      :small-title="true"
      :title="$t('superPass.purchase.title')"
      :sub-title="$t('superPass.purchase.subTitle')"
      :submit-text="$t('payment.pay')"
      @back="goBack"
      @submit="submit"
    >
      <div class="transfer__form">
        <Loader v-if="isLoadedTransfer" />
        <template v-else>
          <div class="transfer__form-cards">
            <PurchasePassCard title="Выбранная игра:" :entity="game" @edit="changeModal('SuperPassGames')" />
            <PurchasePassCard title="Выбранный пасс:" :entity="pass" @edit="changeModal('SuperPassPasses')" />

            <div class="transfer__form-payment">
              <Input
                :value="pass.amount[$store.state.currency] + ` ${currencyMap[$store.state.currency]}`"
                :disabled="true"
                icon-text="₽"
                :placeholder="$t('transfer.nickname')"
              />
              <Input
                :value="pass.robux + ' R$'"
                :disabled="true"
                icon="/base/robux.svg"
                :placeholder="$t('transfer.nickname')"
              />
            </div>
          </div>

          <div class="transfer__form-footer">
            <div v-if="error" class="transfer__form-footer-error">{{ error }}</div>

            <p class="payment__main__result">
              {{ $t('payment.toPay') }}:
              <span>
                {{ pass.amount[$store.state.currency] }}
                {{ currencyMap[$store.state.currency] }}
              </span>
            </p>
          </div>
        </template>
      </div>
    </form-layout>
  </div>
</template>

<script>
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import PurchasePassCard from '@/components/PurchasePassCard/PurchasePassCard.vue'
import Input from '@/components/Base/Input/Input.vue'
import Loader from '@/components/LoaderBar/LoaderBar.vue'

export default {
  name: 'SuperPassPurchase',
  components: {
    Loader,
    Input,
    PurchasePassCard,

    FormLayout
    // Loader
  },
  inject: ['currencyMap'],

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    game: {
      type: Object,
      default: () => {}
    },
    pass: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isLoadedTransfer: false,
      error: '',
      balanceError: ''
    }
  },
  methods: {
    checkBalanceAndRedirect() {
      const currency = this.$store.state.currency?.toLowerCase()
      const balance = Number(this.$store.getters.balance) || 0
      const requiredAmount = Number(this.pass.amount[currency]) || 0

      if (requiredAmount > balance) {
        this.$analytics.send('purch_super_e1_payment_insufficient', {})

        // Сохраняем данные о заказе
        this.$store.commit('paymentsOrder/setAmount', requiredAmount)
        this.$store.commit('paymentsOrder/setRobuxAmount', this.pass.robux)
        this.$store.commit('paymentsOrder/setRobloxData', {
          nickname: this.data?.nickname
        })
        this.$store.commit('paymentsOrder/setSuperPassData', {
          isSuperPass: true,
          superPassId: this.pass.id
        })

        // Редирект на форму оплаты
        this.$emit('changeModal', {
          modal: 'TransferPaymentMethod'
        })
      }
    },
    goBack() {
      this.$emit('changeModal', {
        modal: 'TransferCharacters',
        data: []
      })
    },
    changeModal(modal) {
      this.$emit('changeModal', {
        modal
      })
    },
    async submit() {
      if (!(await this.checkSuperPassStock())) {
        this.changeModal('SuperPassStockInfo')
        return
      }
      this.error = ''

      const requestHeaders = new Headers({
        Authorization: `Bearer ${this.$cookies.get('access_token')}`
      })

      const requestParams = {
        method: 'GET',
        headers: requestHeaders
      }

      const params = new URLSearchParams({
        superpass_id: this.pass.id,
        username: this.data?.nickname,
        currency: this.$store.state.currency?.toUpperCase()
      })

      fetch('https://transfer.backend-pier.com/make_superpass_order_new_new?' + params.toString(), requestParams)
        .then(res => res.json())
        .then(data => {
          if (!data.status) {
            this.error = this.$t('general.errors.server')
            return
          }

          this.$analytics.send('purch_super_4_payment_balance', {})

          this.$router.push({ name: 'History', query: { method: 'superPass' } })
        })
        .catch(err => {
          console.error('Fetch error:', err)
          this.error = this.$t('general.errors.server')
        })
    },
    async checkActivePassOrder() {
      const requestHeaders = new Headers({
        Authorization: `Bearer ${this.$cookies.get('access_token')}`
      })

      const requestParams = {
        method: 'GET',
        headers: requestHeaders
      }

      try {
        const response = await fetch('https://transfer.backend-pier.com/active_superpass_orders_new', requestParams)
        const data = await response.json()
        const activeInGameOrders = data?.orders?.filter(order => order?.in_game)
        const isActiveOrder = !!activeInGameOrders?.length && this.game?.in_game

        if (isActiveOrder) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('superPass.purchase.activeOrder'),
            type: 'warning'
          })

          await this.$router.push({
            name: 'History',
            query: { method: 'superPass' }
          })
        } else {
          this.isLoadedTransfer = false
        }
      } catch (error) {
        console.error('Error fetching active pass order:', error)
        this.isLoadedTransfer = false
      } finally {
        this.isLoadedTransfer = false
      }
    },
    async checkSuperPassStock() {
      const requestHeaders = new Headers({
        Authorization: `Bearer ${this.$cookies.get('access_token')}`
      })

      const requestParams = {
        method: 'GET',
        headers: requestHeaders
      }

      try {
        const response = await fetch('https://transfer.backend-pier.com/superpass_stock_new', requestParams)
        const data = await response.json()

        if (data.suppliers) {
          return data.suppliers?.length
        } else {
          this.isLoadedTransfer = false
        }
      } catch (error) {
        console.error('Error fetching active pass order:', error)
      } finally {
        this.isLoadedTransfer = false
      }
    }
  },
  created() {
    // Проверка баланса при создании компонента
    this.checkBalanceAndRedirect()
    this.checkActivePassOrder()
  }
}
</script>

<style lang="scss">
@import './superPassPurchase';
</style>
